import { InventryLocation } from "@dana/Handlers/ProductAvailabilityHandler";
import { SelectedInventryLocationsActions } from "@dana/Store/Data/ProductAvailability/Reducers/SelectedInventryLocationsReducer";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";


export interface SelectedInventryLocationsParameter {
    selectedLocations?: InventryLocation[];
    productId: string;
}
type HandlerType = Handler<SelectedInventryLocationsParameter,
    DispatchProp<SelectedInventryLocationsActions>>;

export const UpdateLocations: HandlerType = props => {
    props.dispatch({
        type: "SelectedInventryLocations/UpdateLocations",
        selectedLocations: props.parameter.selectedLocations,
        productId: props.parameter.productId
    });
}
export const chain = [
    UpdateLocations
];

const updateSelectedInventryLocations = createHandlerChainRunner(chain, "UpdateSelectedInventryLocations");
export default updateSelectedInventryLocations;
